import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e6892b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "context" }
const _hoisted_6 = { class: "route_label" }
const _hoisted_7 = {
  key: 1,
  class: "toggle"
}

import { useI18n } from "vue-i18n";
import {
  computed,
  ComputedRef,
  inject,
  onMounted,
  ref,
  onUnmounted,
} from "vue";
import { useRouter } from "vue-router";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import provide_key from "@/constant/provide_key";
import DropdownSheet from "./DropdownSheet.vue";
import useToggleLanguage from "@/utils/useToggleLanguage";
import routeHash from "@/constant/router_hash";
import DropdownBar from "./DropdownBar.vue";

interface routeChildType {
  path: string;
  title: string;
}

interface routeType {
  path: string;
  title: string;
  children?: routeChildType[];
  showPopover?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

_useCssVars(_ctx => ({
  "7c127c5d": (hoverColor.value),
  "2d604a96": (borderBottomColor.value)
}))

gsap.registerPlugin(ScrollTrigger);
const { t } = useI18n();
const router = useRouter();
const visible = ref<boolean>(false);


const showPopover = ref(false);
const scrollTop = ref(0);
const navBarRef = ref<null | HTMLElement>(null);

const scrollToUpdate = computed(() => {
  if (navBarRef.value) {
    return navBarRef.value.clientHeight < scrollTop.value;
  }
  return false;
});

const isLightSurface = computed(
  () =>
    scrollToUpdate.value ||
    router.currentRoute.value.path === "/projects" ||
    router.currentRoute.value.path.startsWith("/news")
);
const hoverColor = computed(() => isLightSurface.value ? '#002fa5' : '#a3a3a3')
const borderBottomColor = computed(() => isLightSurface.value ? '#002fa5' : '#fff')
const isRouteActive = (path: string) =>
  router.currentRoute.value.path === path ||
  (path !== "/" && router.currentRoute.value.path.startsWith(`${path}/`));

const routes: ComputedRef<routeType[]> = computed(() => [
  {
    path: "/",
    title: t("navbar.HOME"),
  },
  {
    path: "/solution",
    title: t("navbar.SOLUTION"),
    children: [
      {
        path: routeHash.AIR_TO_LIQUID_COOLING,
        title: t("footer.WIND_TO_LIQUID"),
      },
      {
        path: routeHash.SYSTEMIC_LIQUID_COOLING,
        title: t("footer.LIQUID_COOLING"),
      },
      {
        path: routeHash.RDHX_AIR_COOLED,
        title: t("footer.LIQUID_COOLING_REAR_DOOR"),
      },
    ],
  },
  {
    path: "/service",
    title: t("navbar.SERVICE"),
    children: [
      {
        path: routeHash.IDC_LIQUID_COOLING,
        title: t("footer.DATA_CENTER"),
      },
      {
        path: routeHash.AIGC_INFRASTRUCTURE,
        title: t("footer.COMPUTATIONAL_EQUIPMENT"),
      },
    ],
  },
  {
    path: "/product",
    title: t("navbar.PRODUCT"),
    children: [
      {
        path: routeHash.L2L_PRODUCT,
        title: t("product.L2L_NAV"),
      },
      {
        path: routeHash.L2A_PRODUCT,
        title: t("product.L2A_NAV"),
      },
      {
        path: routeHash.RDHx_PRODUCT,
        title: t("product.RDHx_NAV"),
      },
      {
        path: routeHash.OTHERS_PRODUCT,
        title: t("product.OTHERS_NAV"),
      },
    ],
  },
  {
    path: "/projects",
    title: t("navbar.PROJECTS"),
  },
  {
    path: "/news",
    title: t("navbar.NEWS"),
    children: [
      {
        path: "/news/selection",
        title: t("navbar.SELECTION_NOTICE"),
      },
      {
        path: "/news/award",
        title: t("navbar.AWARD_NOTICE"),
      },
    ],
  },
  {
    path: "/company",
    title: t("navbar.COMPANY"),
  },
]);

const shrink = inject(provide_key.SHRINK);
const { onToggleLanguage } = useToggleLanguage();
const onToggle = () => (visible.value = !visible.value);
const onBack = () => router.push("/");
const onClickButton = () => {
  // location.reload()
  onToggleLanguage()
}

const scrollerEven = () => (scrollTop.value = window.scrollY);

onMounted(() => {
  window.addEventListener("scroll", scrollerEven);
});

onUnmounted(() => {
  window.removeEventListener("scroll", scrollerEven);
});


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: "nav_bar",
    ref_key: "navBarRef",
    ref: navBarRef,
    style: _normalizeStyle({
      'background-color': isLightSurface.value
        ? 'rgba(241, 241, 241, 0.95)'
        : 'rgba(241, 241, 241, 0)',
      borderBottom: isLightSurface.value
        ? '1px solid #c3c3c3'
        : '1px solid transparent',
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: isLightSurface.value ? require('@/assets/logo_band.png') : require('@/assets/logo_white.png'),
          alt: "ALC(Air & Liquid Cooling Technology Limited (HK))",
          onClick: onBack
        }, null, 8, _hoisted_3)
      ]),
      (!_unref(shrink))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "routes",
            style: _normalizeStyle({
        'color': isLightSurface.value ? '#3e3e3e' : '#f2f2f2'
    })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route) => {
              return (_openBlock(), _createElementBlock("div", {
                key: route.title,
                onClick: ($event: any) => (_unref(router).push(route.path)),
                onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showPopover.value = true)),
                class: _normalizeClass(isRouteActive(route.path) ? 'active' : 'route')
              }, [
                _createVNode(DropdownBar, {
                  options: route.children
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(route.title), 1),
                      (route.children)
                        ? (_openBlock(), _createBlock(_component_van_icon, {
                            key: 0,
                            name: "arrow-down",
                            size: "10px",
                            class: "arrow"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["options"])
              ], 42, _hoisted_4))
            }), 128)),
            _createElementVNode("div", {
              class: "toggle_button",
              onClick: onClickButton
            }, _toDisplayString(_ctx.$t("navbar.PORTAL")), 1)
          ], 4))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_van_icon, {
              name: "wap-nav",
              size: "3rem",
              color: isLightSurface.value ? '#000' : '#fff',
              onClick: onToggle
            }, null, 8, ["color"])
          ])),
      (visible.value)
        ? (_openBlock(), _createBlock(DropdownSheet, {
            key: 2,
            onOnClose: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false)),
            routes: routes.value
          }, null, 8, ["routes"]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}
}

})